import { Flex, Form, Switch } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = StepProps

export const StepAbilities: React.FC<Props> = props => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4} style={{ marginBottom: '32px' }}>
          How would you like me to assist with your inbox?
        </TitlePrimary>

        <Flex vertical gap={16} className="w-full">
          <CommonClient.Form.InputWrapper
            label="Draft email replies"
            description="I'll craft email drafts direclty in your inbox for you to review and send"
          >
            <Form.Item name={['abilities', 'draftEmails']}>
              <Switch size="small" />
            </Form.Item>
          </CommonClient.Form.InputWrapper>

          <CommonClient.Form.InputWrapper
            label="Organize emails with labels"
            description="I'll categorize your emails into labels like 'Marketing' or 'To reply'"
          >
            <Form.Item name={['abilities', 'labelEmails']}>
              <Switch size="small" />
            </Form.Item>
          </CommonClient.Form.InputWrapper>

          <CommonClient.Form.InputWrapper
            label="Archive less important emails"
            description="I'll automatically archive emails to keep your inbox clean"
          >
            <Form.Item name={['abilities', 'archiveEmails']}>
              <Switch size="small" />
            </Form.Item>
          </CommonClient.Form.InputWrapper>

          <CommonClient.Form.InputWrapper
            label="Manage your calendar"
            description="I can schedule, update, and cancel meetings on your behalf"
          >
            <Form.Item name={['abilities', 'manageCalendar']}>
              <Switch size="small" />
            </Form.Item>
          </CommonClient.Form.InputWrapper>

          <CommonClient.Form.InputWrapper
            label="Organize existing emails"
            description="I'll sort your most recent 50 emails to help you get started"
          >
            <Form.Item name={['abilities', 'sortExistingEmails']}>
              <Switch size="small" />
            </Form.Item>
          </CommonClient.Form.InputWrapper>
        </Flex>
      </CommonClient.Onboarding.Step>
    </>
  )
}
